import React from "react";
import PropTypes from "prop-types";

const LogoIcon = (props) => {
  const { size } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 58 58"
    >
      <path
        stroke="#E6E6E6"
        strokeWidth="3"
        d="M2.121 29L29 2.121 55.879 29 29 55.879 2.121 29z"
      ></path>
      <path
        fill="#E6E6E6"
        d="M29.124 16.76h2.88v15.18c0 1.34-.21 2.44-.63 3.3-.42.84-.95 1.51-1.59 2.01-.62.48-1.29.81-2.01.99-.72.2-1.38.3-1.98.3-1.5 0-2.77-.38-3.81-1.14-1.02-.78-1.67-1.95-1.95-3.51l2.82-.63c.16.8.49 1.43.99 1.89.5.46 1.15.69 1.95.69.72 0 1.29-.14 1.71-.42.44-.28.78-.64 1.02-1.08.24-.46.4-.98.48-1.56.08-.58.12-1.17.12-1.77V16.76z"
      ></path>
    </svg>
  );
};

LogoIcon.propTypes = {
  size: PropTypes.number,
};

export default LogoIcon;
